import { Box, Text, TooltipRenderer, IconHelp } from 'braid-design-system';
import type { ComponentProps } from 'react';

interface TooltipHelpIconProps {
  tooltip: ComponentProps<typeof Text>['children'];
}

export const TooltipHelpIcon = ({ tooltip }: TooltipHelpIconProps) => (
  <TooltipRenderer
    id={`${tooltip}HelpTooltip`}
    tooltip={<Text>{tooltip}</Text>}
  >
    {({ triggerProps }) => (
      <Box aria-label="Help" component="span" {...triggerProps}>
        <IconHelp />
      </Box>
    )}
  </TooltipRenderer>
);
